import { OutlinedTextField } from "../../../../../../common/components";
import { usePageStrings } from "../../../../../../common/hooks";

interface IComponentProperties {
  accountName: string,
  clientId: string,
  loginNameProperty: string,
  authorizationServer: string,
}

export function SSOProviderOKTA(props: IComponentProperties) {



  const pageStrings = usePageStrings();
  return (
    <>
 
        <OutlinedTextField
          name="okta_accountName"
          required
          label={pageStrings.authenticationPage.formItem_accountName_label}
          placeholder={pageStrings.authenticationPage.formItem_accountName_label}
          value={props.accountName}
        ></OutlinedTextField>
        
        <OutlinedTextField
          name="okta_clientId"
          required
          label={pageStrings.authenticationPage.formItem_clientId_label}
          placeholder={pageStrings.authenticationPage.formItem_clientId_label}
          value={props.clientId}
        ></OutlinedTextField>

        <OutlinedTextField
          name="okta_loginNameProperty"
          required
          label= {pageStrings.authenticationPage.formItem_usernamePropertyName_label}
          placeholder={pageStrings.authenticationPage.formItem_usernamePropertyName_label}
          value={props.loginNameProperty}
        ></OutlinedTextField>

        {/* <OutlinedTextField
          name="okta_authorizationServer"
          label={pageStrings.authenticationPage.formItem_authorizationServer_label}
          placeholder={pageStrings.authenticationPage.formItem_authorizationServer_label}
          value={props.authorizationServer}
        ></OutlinedTextField> */}

    </>
  );
}
